'use client'

import { WIZARD_COPY } from '../../const'

import styles from './WizardHeader.module.scss'

export function WizardHeader() {
  return (
    <>
      <h2 id="graft-filter-wizard-title" className={styles.title}>
        {WIZARD_COPY.title}
      </h2>
      <p className={styles.description}>{WIZARD_COPY.description}</p>
    </>
  )
}
